<template>
  <div class="group-box">
    <div class="box-list">
      <a-form :label-col="{ span: 2 }" :model="form" :wrapper-col="{ span: 8, offset: 1 }" autocomplete="off" name="basic">
        <a-form-item label="头像" name="logo">
          <div class="image">
            <a-upload
              :action="action"
              :data="formData"
              :headers="header"
              :show-upload-list="false"
              class="avatar-uploader"
              name="image"
              @change="
                e => {
                  uploadLogo(e, 'header_url');
                }
              "
            >
              <img :src="form.header_url" alt="品牌LOGO" fit="fill" style="width: 80px; height: 80px; object-fit: cover; cursor: pointer" />
            </a-upload>
          </div>
        </a-form-item>
        <a-form-item label="姓名" name="name">
          <a-input v-model:value="form.name" placeholder="请输入姓名" />
        </a-form-item>
        <a-form-item label="手机号" name="phone">
          <a-input v-model:value="form.phone" placeholder="请输入手机号" />
        </a-form-item>
        <a-form-item label="企业微信URL" name="qy_url">
          <a-textarea v-model:value="form.qy_url" placeholder="企业微信URL" />
        </a-form-item>
        <a-form-item label="微信二维码" name="logo">
          <div class="image">
            <a-upload
              :action="action"
              :data="formData"
              :headers="header"
              :show-upload-list="false"
              class="avatar-uploader"
              name="image"
              @change="
                e => {
                  uploadLogo(e, 'weixin_qr');
                }
              "
            >
              <img :src="form.weixin_qr" alt="微信二维码" fit="fill" style="width: 150px; height: 150px; object-fit: cover; cursor: pointer" />
            </a-upload>
          </div>
        </a-form-item>

        <a-form-item label="状态" name="status">
          <a-radio-group v-model:value="form.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="2">停用</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :wrapper-col="{ offset: 5, span: 16 }">
          <a-button html-type="submit" type="primary" @click="saveConfig">保存 </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from 'vue';
import { customerDetails, customerSaveData } from '@/api/api';
import { message } from 'ant-design-vue';
import { baseRequestUrl } from '../../../../config.js';

export default {
  components: {},
  setup() {
    const config = reactive({
      // 上传
      uploadLoading: false,
      action: baseRequestUrl + '/h5/upload/uploadImg' + '?info=' + JSON.parse(sessionStorage.getItem('landlordInfo')).info,
      header: {
        token: JSON.parse(sessionStorage.getItem('landlordInfo')).token,
        version: '1.0.0',
        source: '1',
      },
      formData: {
        module: 'pms',
        type: 'logo',
      },
      form: {
        header_url: '',
        status: 1,
        name: '',
        qy_url: '',
        phone: '',
        weixin_qr: '',
      },
      //   保存设置
      saveConfig() {
        customerSaveData(config.form).then(res => {
          message.success(res.msg);
          config.getConfig();
        });
      },
      // 获取设置
      getConfig() {
        customerDetails().then(res => {
          if (res.data) {
            Object.keys(config.form).forEach(i => {
              config.form[i] = res.data[i];
            });
          }
        });
      },
      //  上传图片
      uploadLogo(info, key) {
        if (info.file.status === 'done') {
          config.form[key] = info.file.response.data.url;
        }
      },
    });

    onMounted(() => {
      config.getConfig();
    });

    return {
      ...toRefs(config),
    };
  },
};
</script>

<style lang="scss" scoped>
:deep(.areaSel) {
  input::-webkit-input-placeholder {
    color: #262626;
  }

  input:-ms-input-placeholder {
    // IE 10 +
    color: #262626;
  }

  input:-moz-placeholder {
    // Firefox 4 -18
    color: #262626;
  }

  input::-moz-placeholder {
    // Firefox 19 +
    color: #262626;
  }
}

.group-box {
  background-color: #fff;
  width: 100%;
  //   box-shadow: 0 0 5px #99999933;
  .box-title {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-bottom: 1px solid #f2f2f2;

    .title {
    }

    .btn {
    }
  }

  .box-list {
    padding: 20px;

    .list-lef {
      .lef-name {
        margin-bottom: 5px;
      }

      .lef-num {
      }
    }

    .list-rig {
      display: flex;
    }
  }
}
</style>
